import Plyr from './plyr/src/js/plyr';

export function initalize() {
  const videos = document.getElementsByClassName('video');
  for (let i = 0; i < videos.length; ++i) {
    const video  = videos[i];
    let config = JSON.parse(video.getAttribute('data-plyr-config'));
    config = Object.assign({autopause: false}, config);
    try {
      const player = new Plyr(video, config);
    } catch (_) {}
  }
}

export function player(video, config) {
  try {
    const player = new Plyr(video, config);
    const promise = new Promise(
        resolve => { player.on('ready', () => { resolve(player); }); });
    return promise;
  } catch (_) {
    return Promise.resolve(null);
  }
}

